var _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTitleCreatePlan2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 87,
    viewBox: "0 0 110 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.746 43.5L45.3095 6.58569V80.4144L23.746 43.5Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110 43.5L88.4365 6.58569V80.4144L110 43.5Z",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3095 6.58569H88.4365V80.4144H45.3095V6.58569Z",
    fill: "#000000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 43.5L25.4921 0V87L0 43.5Z",
    fill: "#003478"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.968 43.5L76.4762 0V87L101.968 43.5Z",
    fill: "#003478"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4921 0H76.4762V87H25.4921V0Z",
    fill: "#003478"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.9683,
    cy: 23.2232,
    rx: 13.9683,
    ry: 13.8645,
    fill: "#000000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5646 71.1562H76.2921V60.8848H51.6759L68.531 46.4893C72.7643 42.832 75.8218 38.7857 75.8218 31.7047C75.8218 20.6551 67.9822 15.1304 57.8691 15.1304C46.9721 15.1304 38.9758 20.6551 38.2702 32.0159L50.0296 32.8719C50.3431 28.9034 52.9302 25.8687 57.242 25.8687C60.8482 25.8687 64.0624 28.1253 64.0624 31.8603C64.0624 35.2063 61.3185 37.5407 59.1235 39.5639L37.5646 58.7838V71.1562Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleCreatePlan2);
export default __webpack_public_path__ + "static/media/titleCreatePlan2.309f5068ae324948df238c18728930b8.svg";
export { ForwardRef as ReactComponent };